import {
  AiOutlineCloudSync,
  AiOutlineHome,
} from 'react-icons/ai';
import {
  BsArrowLeftSquare,
  BsArrowRightSquare,
} from 'react-icons/bs';
import {
  FaHeart,
  FaHome,
  FaPhotoVideo,
  FaRegBuilding,
  FaRegHeart,
} from 'react-icons/fa';
import {
  FaBarcode,
  FaRegStar,
  FaRegStarHalfStroke,
  FaStar,
} from 'react-icons/fa6';
import { FiExternalLink } from 'react-icons/fi';
import { GoPeople } from 'react-icons/go';
import {
  IoIosArrowBack,
  IoIosArrowDown,
  IoIosArrowUp,
} from 'react-icons/io';
import {
  IoClose,
  IoEarthSharp,
  IoLanguage,
  IoOptions,
  IoOptionsOutline,
  IoSettingsOutline,
  IoSettingsSharp,
  IoVolumeHigh,
  IoVolumeMute,
} from 'react-icons/io5';
import { LiaTrashAltSolid } from 'react-icons/lia';
import {
  LuArrowLeftSquare,
  LuArrowRightSquare,
  LuBook,
  LuSend,
} from 'react-icons/lu';
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
  MdOutlineCalendarMonth,
  MdOutlineCollectionsBookmark,
} from 'react-icons/md';
import { RxDimensions } from 'react-icons/rx';
import { TfiEmail } from 'react-icons/tfi';

export const ArrowDoubleLeftIcon = MdKeyboardDoubleArrowLeft;
export const ArrowDoubleRightIcon = MdKeyboardDoubleArrowRight;
export const ArrowSingleDownIcon = IoIosArrowDown;
export const ArrowSingleLeftIcon = IoIosArrowBack;
export const ArrowSingleUpIcon = IoIosArrowUp;
export const ArrowSquareLeftIcon = LuArrowLeftSquare;
export const ArrowSquareRightIcon = LuArrowRightSquare;
export const ArrowSquareLeftIcon2 = BsArrowLeftSquare;
export const ArrowSquareRightIcon2 = BsArrowRightSquare;
export const BarcodeIcon = FaBarcode;
export const BookIcon = LuBook;
export const BuildingIcon = FaRegBuilding;
export const CalendarIcon = MdOutlineCalendarMonth;
export const CloseIcon = IoClose;
export const CollectionIcon = MdOutlineCollectionsBookmark;
export const DimensionsIcon = RxDimensions;
export const EarthIcon = IoEarthSharp;
export const EmailIcon = TfiEmail;
export const ExternalLinkIcon = FiExternalLink;
export const FilterIcon = IoOptions;
export const FilterOutlineIcon = IoOptionsOutline;
export const HeartIcon = FaHeart;
export const HeartOutlineIcon = FaRegHeart;
export const HomeIcon = FaHome;
export const HomeOutlineIcon = AiOutlineHome;
export const LanguageIcon = IoLanguage;
export const LoadingIcon = AiOutlineCloudSync;
export const MediaIcon = FaPhotoVideo;
export const PeopleIcon = GoPeople;
export const SettingsIcon = IoSettingsSharp;
export const SettingsOutlineIcon = IoSettingsOutline;
export const ShareIcon = LuSend;
export const StarDemiIcon = FaRegStarHalfStroke;
export const StarEmptyIcon = FaRegStar;
export const StarFullIcon = FaStar;
export const TrashCan = LiaTrashAltSolid;
export const VolumeHighIcon = IoVolumeHigh;
export const VolumeOffIcon = IoVolumeMute;
